import { render, staticRenderFns } from "./exchangeVideoVip.vue?vue&type=template&id=511f1ebb&scoped=true&"
import script from "./exchangeVideoVip.vue?vue&type=script&lang=js&"
export * from "./exchangeVideoVip.vue?vue&type=script&lang=js&"
import style0 from "./exchangeVideoVip.vue?vue&type=style&index=0&id=511f1ebb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511f1ebb",
  null
  
)

export default component.exports